let seq = 1;
export function getSeq() {
  return ++seq;
}
